import { withPermissionGuard } from '@libs/permission'
import { CreateCampaignPage } from './CreateCampaignPage'
import { withCreateCampaignPage } from './withCreateCampaignPage'

const Connected = withPermissionGuard(
  withCreateCampaignPage(CreateCampaignPage),
  'promotionCampaign',
  'create'
)

export { Connected as CreateCampaignPage }
